<template>
  <div class="row my-3">
    <Card  icon="gift-dynamic-gradient.png"
           title="Pre Order"
           sub-title="This Week"
           count="150"></Card>
    <Card  icon="mail-dynamic-gradient.png"
        title="Email"
        sub-title="This Week"
        count="200"></Card>
    <Card icon="calender-dynamic-gradient.png"
        title="Schedules"
        sub-title="Today"
        count="10"></Card>
    <Card icon="wallet-dynamic-gradient.png"
        title="Wallet"
        sub-title="This Month"
        count="13"></Card>
  </div>
  <div class="row">
    <div class="col-8">
      <div class="card border-0  shadow-sm rounded rounded-3">
        <div class="card-body">
          <p class="text-black-50 mb-0 fw-bold">
            <i class="fa-solid fa-cart-shopping text-primary"></i>
            Ordering lists
          </p>
          <Table></Table>
        </div>
      </div>
    </div>
    <div class="col-4">
     <Transaction></Transaction>
      <div class="mt-3">
        <NewUsersAndVisitor></NewUsersAndVisitor>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Card from "@/components/Card";
import BarChart from "@/components/BarChart";
import Table from "@/components/Table";
import Transaction from "@/components/Transaction";
import NewUsersAndVisitor from "@/components/NewUsersAndVisitor";
export default {
  name: 'HomeView',
  components: {
    NewUsersAndVisitor,
    Transaction,
    Table,
    BarChart,
    Card,
  }
}
</script>
